import makeStyles from "e100-react-components/lib/styles/makeStyles";
import { getColorAutoByStatus } from "shared/utils";

import { CarAvatarProps } from './ui';

interface Props extends Pick<
  CarAvatarProps,
  'avatarSize'
> {
  autoActiveStatus: number;
}

export const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  avatar: {
    color: "#515B69",
    backgroundColor: "rgba(81, 91, 105, 0.1)",
  },
  badge: {
    backgroundColor: ({ autoActiveStatus }: Props) =>
      getColorAutoByStatus(autoActiveStatus),
    top: ({ avatarSize }: Props) => (avatarSize === "large" ? '27%' : '14%'),
    right: ({ avatarSize }: Props) => (avatarSize === "large" ? '22%' : '14%'),
  },
}));
